import {NgModule} from '@angular/core';
import {HttpClientModule} from '@angular/common/http';
import {RouterModule} from '@angular/router';
import {MatButtonModule} from '@angular/material/button';
import {MatDividerModule} from '@angular/material/divider';
import {MatIconModule} from '@angular/material/icon';
import {MatMenuModule} from '@angular/material/menu';
import {FuseFullscreenModule} from '@fuse/components/fullscreen';
import {FuseLoadingBarModule} from '@fuse/components/loading-bar';
import {FuseNavigationModule} from '@fuse/components/navigation';
import {LanguagesModule} from 'app/layout/common/languages/languages.module';
import {UserModule} from 'app/layout/common/user/user.module';
import {SharedModule} from 'app/shared/shared.module';
import {ClassicLayoutComponent} from 'app/layout/layouts/vertical/classic/classic.component';
import { BreadcrumbModule } from 'app/layout/common/breadcrumb/breadcrumb.module';
import { CommonModule } from '@angular/common';
import { ScrollTopModule } from 'app/layout/common/scrollToTop/scroll-top.module';
import { MobileLanguagesModule } from 'app/layout/common/mobile-languages/mobile-languages.module';
import { MobileMenuModule } from 'app/layout/common/mobile-menu/mobile-menu.module';

@NgModule({
    declarations: [
        ClassicLayoutComponent
    ],
    imports: [
        HttpClientModule,
        RouterModule,
        MatButtonModule,
        MatDividerModule,
        MatIconModule,
        MatMenuModule,
        FuseFullscreenModule,
        FuseLoadingBarModule,
        FuseNavigationModule,
        LanguagesModule,
        MobileLanguagesModule,
        MobileMenuModule,
        UserModule,
        BreadcrumbModule,
        CommonModule,
        SharedModule,
        ScrollTopModule,
    ],
    exports: [
        ClassicLayoutComponent
    ]
})
export class ClassicLayoutModule {
}
